import styled from 'styled-components';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'react';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../Box/Box.es.js';
var StyledShelf = styled(Box).withConfig({
  componentId: "czap7c-0"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;grid-template-rows:1fr 1fr 1fr;grid-template-areas:'topLeft topCenter topRight' 'middleLeft middleCenter middleRight' 'bottomLeft bottomCenter bottomRight';"]);
var ShelfBaseStyles = "\n    position: relative;\n    display: flex;\n";
var StyledTop = styled(Box).withConfig({
  componentId: "czap7c-1"
})(["", " grid-area:topLeft / topLeft / topLeft / topRight;"], ShelfBaseStyles);
var Top = maestroComponent("Shelf.Top", StyledTop);
var StyledTopLeft = styled(Box).withConfig({
  componentId: "czap7c-2"
})(["", " grid-area:topLeft;justify-content:flex-start;align-items:flex-start;"], ShelfBaseStyles);
var TopLeft = maestroComponent("Shelf.TopLeft", StyledTopLeft);
var StyledTopCenter = styled(Box).withConfig({
  componentId: "czap7c-3"
})(["", " grid-area:topCenter;justify-content:center;align-items:flex-start;"], ShelfBaseStyles);
var TopCenter = maestroComponent("Shelf.TopCenter", StyledTopCenter);
var StyledTopRight = styled(Box).withConfig({
  componentId: "czap7c-4"
})(["", " grid-area:topRight;justify-content:flex-end;align-items:flex-start;"], ShelfBaseStyles);
var TopRight = maestroComponent("Shelf.TopRight", StyledTopRight);
var StyledMiddle = styled(Box).withConfig({
  componentId: "czap7c-5"
})(["", " grid-area:middleLeft / middleLeft / middleLeft / middleRight;justify-content:flex-start;align-items:flex-start;"], ShelfBaseStyles);
var Middle = maestroComponent("Shelf.Middle", StyledMiddle);
var StyledMiddleLeft = styled(Box).withConfig({
  componentId: "czap7c-6"
})(["", " grid-area:middleLeft;justify-content:flex-start;align-items:center;"], ShelfBaseStyles);
var MiddleLeft = maestroComponent("Shelf.MiddleLeft", StyledMiddleLeft);
var StyledMiddleCenter = styled(Box).withConfig({
  componentId: "czap7c-7"
})(["", " grid-area:middleCenter;justify-content:center;align-items:center;"], ShelfBaseStyles);
var MiddleCenter = maestroComponent("Shelf.MiddleCenter", StyledMiddleCenter);
var StyledMiddleRight = styled(Box).withConfig({
  componentId: "czap7c-8"
})(["", " grid-area:middleRight;justify-content:flex-end;align-items:center;"], ShelfBaseStyles);
var MiddleRight = maestroComponent("Shelf.MiddleRight", StyledMiddleRight);
var StyledLeft = styled(Box).withConfig({
  componentId: "czap7c-9"
})(["", " grid-area:topLeft / topLeft / bottomLeft / topLeft;"], ShelfBaseStyles);
var Left = maestroComponent("Shelf.Left", StyledLeft);
var StyledCenter = styled(Box).withConfig({
  componentId: "czap7c-10"
})(["", " grid-area:topCenter / topCenter / bottomCenter / topCenter;"], ShelfBaseStyles);
var Center = maestroComponent("Shelf.Center", StyledCenter);
var StyledRight = styled(Box).withConfig({
  componentId: "czap7c-11"
})(["", " grid-area:topRight / bottomRight / bottomRight / BottomRight;"], ShelfBaseStyles);
var Right = maestroComponent("Shelf.Right", StyledRight);
var StyledBottom = styled(Box).withConfig({
  componentId: "czap7c-12"
})(["", " grid-area:bottomLeft / bottomLeft / bottomLeft / bottomRight;justify-content:flex-start;align-items:flex-end;"], ShelfBaseStyles);
var Bottom = maestroComponent("Shelf.Bottom", StyledBottom);
var StyledBottomLeft = styled(Box).withConfig({
  componentId: "czap7c-13"
})(["", " grid-area:bottomLeft;justify-content:flex-start;align-items:flex-end;"], ShelfBaseStyles);
var BottomLeft = maestroComponent("Shelf.BottomLeft", StyledBottomLeft);
var StyledBottomCenter = styled(Box).withConfig({
  componentId: "czap7c-14"
})(["", " grid-area:bottomCenter;justify-content:center;align-items:flex-end;"], ShelfBaseStyles);
var BottomCenter = maestroComponent("Shelf.BottomCenter", StyledBottomCenter);
var StyledBottomRight = styled(Box).withConfig({
  componentId: "czap7c-15"
})(["", " grid-area:bottomRight;justify-content:flex-end;align-items:flex-end;"], ShelfBaseStyles);
var BottomRight = maestroComponent("Shelf.BottomRight", StyledBottomRight);
var compoundComponents = {
  Top: Top,
  TopLeft: TopLeft,
  TopCenter: TopCenter,
  TopRight: TopRight,
  Middle: Middle,
  MiddleLeft: MiddleLeft,
  MiddleCenter: MiddleCenter,
  MiddleRight: MiddleRight,
  Left: Left,
  Center: Center,
  Right: Right,
  Bottom: Bottom,
  BottomLeft: BottomLeft,
  BottomCenter: BottomCenter,
  BottomRight: BottomRight
};
var Shelf = maestroComponent("Shelf", StyledShelf, compoundComponents);
export { Shelf };